import { pathJoin } from 'src/reducers/routing/utils'

export const createScheduledExportDetailViewRoutesMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  exports: pathJoin(prefix)('exports').chain,
})
